import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";


export const REBALANCE_INVESTMENTS_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Nome fondo'
    },
    {
        key: 'fundAmount',
        label: 'Importo Attuale'
    },
        {
        key: 'futureFundAmount',
        label: 'Importo Futuro'
    },
    {
        key: 'differenceAmount',
        label: 'Scostamento Importo'
    }
]

export interface IRebalanceInvestmentsRequest {
    policyNumber: string;
}